import { useEffect } from "react";
import { Backspace } from "@phosphor-icons/react";

export default function PinPad({ value, onChange, maxLength = 6, onSubmit, size = "default" }) {
    useEffect(() => {
        const onKey = (e) => {
            if (/^[0-9]$/.test(e.key)) {
                if (value.length < maxLength) onChange(value + e.key);
            } else if (e.key === "Backspace") {
                onChange(value.slice(0, -1));
            } else if (e.key === "Enter" && onSubmit) {
                onSubmit();
            }
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [value, onChange, maxLength, onSubmit]);

    const press = (k) => {
        if (k === "del") onChange(value.slice(0, -1));
        else if (k === "ok") onSubmit && onSubmit();
        else if (value.length < maxLength) onChange(value + k);
    };

    const btnBase =
        "pin-key font-mono flex items-center justify-center bg-bone border border-divider hover:border-moss text-ink";
    const btnSize = size === "kiosk" ? "h-20 text-3xl" : "h-16 text-2xl";

    const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "del", "0", "ok"];

    return (
        <div className="w-full max-w-sm mx-auto" data-testid="pin-pad">
            <div className="flex justify-center gap-3 mb-6" aria-label="PIN indicator">
                {Array.from({ length: maxLength }).map((_, i) => (
                    <div
                        key={i}
                        className={`w-3 h-3 border ${
                            i < value.length ? "bg-moss border-moss" : "bg-transparent border-divider"
                        }`}
                        data-testid={`pin-dot-${i}`}
                    />
                ))}
            </div>
            <div className="grid grid-cols-3 gap-2">
                {keys.map((k) => (
                    <button
                        key={k}
                        type="button"
                        onClick={() => press(k)}
                        disabled={k === "ok" && value.length === 0}
                        className={`${btnBase} ${btnSize} ${
                            k === "ok" ? "bg-moss text-bone border-moss hover:bg-moss-hover" : ""
                        } ${k === "del" ? "bg-stone" : ""} disabled:opacity-40`}
                        data-testid={`pin-key-${k}`}
                    >
                        {k === "del" ? <Backspace size={24} weight="light" /> : k === "ok" ? "Enter" : k}
                    </button>
                ))}
            </div>
        </div>
    );
}
